// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rxiW2","container--unfolded":"styles_container--unfolded__TZ8bs"};